import type { IncentiveListItem } from '../types';

let cachedItem: IncentiveListItem | null = null;

export function getCachedIncentiveListItem(id: string): IncentiveListItem | null {
  return cachedItem?.id === id ? cachedItem : null;
}

export function setCachedIncentiveListItem(item: IncentiveListItem) {
  cachedItem = item;
}
